module.exports = __webpack_public_path__ + "img/85.f934af1b.jpg";